import React, { useState, Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { useContextBridge } from '@react-three/drei'
import * as THREE from 'three'
import { HelmetProvider } from 'react-helmet-async'
import { Perf } from 'r3f-perf'
import { MousePointer2 } from 'lucide-react'

import { SceneXyz3D } from './experience/SceneXyz3D.jsx'
import
  {
    HtmlOverlay,
    ProgressLoader,
    SplashScreen,
    Seo,
    WebCrafterProvider,
    useWebCrafter,
    WebCrafterContext,
    isDebugMode,
    OrbitNavigation,
  } from '@webcrafter/common'

const GL_CONFIG = {
  alpha: false,
  toneMapping: THREE.ACESFilmicToneMapping,
  toneMappingExposure: 1,
}

const SCENE_PATH = 'assets/scene.glb'

const TUTORIAL_STEPS = [
  {
    icon: <MousePointer2 className="text-green-400" />,
    title: 'Explore Links',
    description: 'Click on the various 3D icons to open links or view content.'
  }
]

export function Xyz3D()
{
  const isDebugging = isDebugMode

  return (
    <HelmetProvider>
      <WebCrafterProvider isDebugging={isDebugging}>
        <WebCrafterApp />
      </WebCrafterProvider>
    </HelmetProvider>
  )
}

function WebCrafterApp()
{
  const [ showPopup, setShowPopup ] = useState(false)
  const [ popupContent, setPopupContent ] = useState(null)
  const { isLoaded, isDebugging } = useWebCrafter()
  const ContextBridge = useContextBridge(WebCrafterContext)

  return (
    <>
      <div className="absolute inset-0 bg-black">
        <Canvas shadows="soft" gl={GL_CONFIG}>
          <ContextBridge>
            <Suspense fallback={null}>
              <SceneXyz3D
                path={SCENE_PATH}
                setShowPopup={setShowPopup}
                setPopupContent={setPopupContent}
                isDebugging={isDebugging}
              />
            </Suspense>
            {isDebugging && <Perf />}
          </ContextBridge>
        </Canvas>
      </div>

      {!isLoaded && <ProgressLoader />}

      <HtmlOverlay
        content={popupContent}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
      />

      {isLoaded && (
        <>
          <SplashScreen
            tutorial={TUTORIAL_STEPS}
            title="Welcome"
            body="Explore your 3D Link in Bio."
            buttonText="Enter"
          />
          <Seo />
          <OrbitNavigation />
        </>
      )}
    </>
  )
}

export default Xyz3D
